<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="pa-6"
    elevation="0"
    outlined
  >
    <slot/>
  </v-card>
</template>

<script>
  export default {
    name: 'LargeBaseCard',
  }
</script>

<style scoped>

</style>
